import React from "react";
import { getRequest } from "../../api/axiosRequests";
import CardAdminExercise from "../components/CardAdminExercise";
import ExerciseForm from "../components/ExerciseForm";
import SearchBar from "../../common/components/SearchBar";

import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Container } from "react-bootstrap";

export default function AdminExercises() {
  const [logged, setLogged] = useState(true);
  const [exercises, setExercises] = useState([]);
  const [primaryTypes, setPrimaryTypes] = useState([]);
  const [filteredExercises, setFilteredExercises] = useState([]);
  const [currentExercise, setCurrentExercise] = useState({ id: -1 });
  const [showEditForm, setShowEditForm] = useState(false);

  // API Requests
  async function fetchRole() {
    try {
      const headers = { Authorization: localStorage.getItem("jwt") };
      const response = await getRequest("userData/", headers);
      const user = response.data["data"];
      const role = await response.data["role"];
      if (role === "Admin") {
        setLogged(true);
      } else {
        setLogged(false);
      }
    } catch (err) {
      setLogged(false);
    }
  }

  async function fetchExercises() {
    try {
      const headers = { Authorization: localStorage.getItem("jwt") };
      const response = await getRequest("exerciseList/", headers);
      setExercises(response["data"]);
      setFilteredExercises(response["data"]);
      setLogged(true);
    } catch (err) {
      setLogged(false);
    }
  }

  async function fetchPrimaryTypes() {
    try {
      const headers = { Authorization: localStorage.getItem("jwt") };
      const response = await getRequest("primaryType/", headers);
      setPrimaryTypes(response["data"]);
    } catch (err) {
      setLogged(false);
    }
  }

  // Button's Callbacks
  const showEditFormCallback = () => {
    setCurrentExercise({ id: -1 });
    setShowEditForm(true);
  };

  const editCallback = (idExercise) => {
    const currentExercise = exercises.filter((ex) => ex.id === idExercise)[0];
    setCurrentExercise(currentExercise);
    setShowEditForm(true);
  };

  const onSearchChange = (name) => {
    const nameLowerCase = name.toLowerCase();
    const filtered = exercises.filter((ex) =>
      ex.name.toLowerCase().includes(nameLowerCase)
    );
    setFilteredExercises(filtered);
  };

  // OnMount DOM
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchRole();
    fetchPrimaryTypes();
    fetchExercises();
  }, []);

  return (
    <>
      {!logged && <Navigate to="/" />}
      {logged && (
        <Container className="mt-2" style={{ paddingBottom: 10 }}>
          <ExerciseForm
            getCurrentExercise={() => {
              return currentExercise;
            }}
            exercises={exercises}
            primaryTypes={primaryTypes}
            onHide={() => {
              setShowEditForm(false);
            }}
            show={showEditForm}
            onSubmit={() => {
              fetchExercises();
            }}
          />
          <div className="align-self-center text-center">
            <div>
              <SearchBar
                onChange={onSearchChange}
                addButton={true}
                onAdd={showEditFormCallback}
              />
            </div>
            <div style={{ width: "100%" }}>
              <div>
                {filteredExercises.map((exercise, idxExercise) => (
                  <div key={exercise.id}>
                    <CardAdminExercise
                      height={80}
                      exercise={exercise}
                      primaryTypes={primaryTypes}
                      isActive={false}
                      editCallback={editCallback}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Container>
      )}
    </>
  );
}
